module.exports = __webpack_public_path__ + "img/modificationOrder.c1ed2fa9.svg";